import { AIMessageChunk } from '@langchain/core/messages';
import { ChatPromptTemplate } from '@langchain/core/prompts';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';

import { llm } from '@/shared/llm';
import { Button } from '@/shared/ui/button';
import { Input } from '@/shared/ui/input';
import { Label } from '@/shared/ui/label';
import { RadioGroup, RadioGroupItem } from '@/shared/ui/radio-group';

export const Route = createFileRoute('/_auth/ai')({
  component: RouteComponent,
});

function RouteComponent() {
  const [text, setText] = useState('');
  const [res, setRes] = useState<null | AIMessageChunk>();
  const [tone, setTone] = useState<string>('Casual');

  const call = async () => {
    const promptTemplate = ChatPromptTemplate.fromMessages([
      [
        'system',
        'You are an assistant that transforms user-provided questions to match a specified tone when addressing a parent. Your goal is to adjust the wording and formality of the question while preserving its original meaning. Tone types: Casual, Moderate, and Polite.',
      ],
      ['user', 'Tone type: {tone}. Question: {question}'],
    ]);

    const promptValue = await promptTemplate.invoke({
      question: text,
      tone: tone,
    });

    setRes(await llm.invoke(promptValue));
  };

  return (
    <div>
      <h1>AI</h1>

      <div>
        <Label>Prompt</Label>
        <Input value={text} onChange={(e) => setText(e.target.value)} />
        <RadioGroup defaultValue="Casual" onValueChange={setTone}>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="Casual" id="r1" />
            <Label htmlFor="r1">Casual</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="Moderate" id="r2" />
            <Label htmlFor="r2">Moderate</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="Polite" id="r3" />
            <Label htmlFor="r3">Polite</Label>
          </div>
        </RadioGroup>
        <Button onClick={call}>Send</Button>
      </div>

      <h2>Result:</h2>
      <div>{res?.content.toString()}</div>
    </div>
  );
}
